<template>
    <div :style="{ width: videoWidth+'px' }">
    <video :width="videoWidth" height="400" controls>
      <source :src="videoEmbedURL" type="video/mp4;type/ogg">
      Tu navegador no soporta la etiqueta de video.
    </video>
  </div>
  </template>
  
  <script>
  export default {
    props: {
        videoEmbedURL: String,
    },
    name: 'VideoPlayer',
    data() {
        return {
        videoWidth: '70%',
        };
    },
    mounted() {
        window.addEventListener('resize', this.updateVideoWidth);
        this.updateVideoWidth();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateVideoWidth);
    },
    methods: {
        updateVideoWidth() {
        this.videoWidth = `${window.innerWidth * 0.65   }`;
        }
    }
  };
  </script>
  
  <style scoped>
  /* Estilos opcionales para tu componente */
  </style>